export default {
  getSubscribeSkuList(data) {
    return this.http(
      'Lottery',
      'get',
      '/api/v1/services/subscribe_goods',
      data
    );
  },
  getSubscribeList(data) {
    return this.http(
      'Lottery',
      'get',
      '/api/v1/service_orders/',
      data
    );
  },
  getSubscribeDetail(id) {
    return this.http(
      'Lottery',
      'get',
      `/api/v1/service_orders/${id}`
    );
  },
  postSubscribeDetail(id, data) {
    return this.http(
      'Lottery',
      'post',
      `/api/v1/service_orders/${id}`,
      data
    );
  }
};
